(function() {
    // 注册组件
    SR.modules.extend('answer.getData', getData);

    function getData(options) {
        var isImmersive = SR.state.isImmersive;
        var showAnimate = SR.state.showAnimate;
        var $body = SR.dom.$body;
        var $scrollWrap = SR.dom.$scrollWrap;
        var loadingTag = SR.data.loadingTag;
        var xhrTimeout = SR.data.xhrTimeout;
        var deviceInfo = SR.data.deviceInfo;
        var userInfo = SR.data.userInfo;
        var historyQuestionsMaxCount = SR.data.historyQuestionsMaxCount;
        var contentWidth = SR.data.deviceInfo.width;
        if (isImmersive || SR.state.isWakeup) {
            contentWidth -= 30;
        } else {
            var pd = SR.permissions.appName === 'haitong' ? (80 + 20) : (9 + 12 + 39 + 20);
            contentWidth -= pd;
            contentWidth = contentWidth > (340 - 20) ? (340 - 20) : contentWidth;
        }
        var enterAnimateStyle = 'animated slideInLeft';
        var outAnimateStyle = 'animated fadeOut';
        var outAnimateTime = showAnimate ? 600 : 0;
        var removeTime = showAnimate ? 200 : 0;

        var urlSearch = location.search && location.search.replace('?', '').replace(/[\?&]ask=([^&#]*)/ig, '');
        var analyticsCookies = Cookies.get('ac') || '{}';
        var isAskAgain = options.askOptions.askAgain === 'reload';
        var inputType = options.askOptions.inputType === undefined ? 0 : options.askOptions.inputType;
        var $targetDom = isAskAgain ? $('#' + options.askOptions.askId) :  $('#' + options.askId);
        if (options.askOptions.showAnimate !== undefined) {
            showAnimate = options.askOptions.showAnimate;
        }
        if (options.askOptions.isLoadHistory) {
            showAnimate = false;
        }
        if (analyticsCookies) {
            try {
                analyticsCookies = JSON.parse(analyticsCookies);
            } catch(err) {
                SR.state.isDebug && console.log('analytics parse error: ', analyticsCookies);
            }
        }
        if ($body.hasClass(loadingTag)) {
            return;
        }
        // loading
        $body.addClass(loadingTag);
        $targetDom.after(template('loading'));
        var $loading = $('.J_loading');
        var extendParams = options.askOptions.extendParams || '';

        $.ajax({
            method: 'POST',
            timeout: xhrTimeout,
            url: '/ask',
            data:
                'ask=' +
                encodeURIComponent(options.question) +
                '&guid=' +
                deviceInfo.guid +
                '&xua=' +
                encodeURIComponent(deviceInfo.xua) +
                '&j=' +
                analyticsCookies.jsid +
                '&u=' +
                userInfo.uid +
                '&lng=' +
                SR.data.location.longitude +
                '&lat=' +
                SR.data.location.latitude +
                '&it=' +
                inputType +
                '&cw=' +
                contentWidth +
                extendParams +
                '&' +
                urlSearch.replace('ask=', 'oask=')
            })
            .done(function(data) {
                var templateHTML;
                var answerDomId = 'answerId-' + Date.now();
                SR.state.isDebug && console.log(data);

                // 广播 beforeRenderAnswer 事件，用于特定场景处理
                // 事件触发的位置不能改变，某些渠道会对 data 进行预先处理
                SR.App.trigger('beforeRenderAnswer', [data]);
                data = SR.middleware.beforeRenderAnswer(data);
                SR.state.isDebug && console.info('fire:beforeRenderAnswer');

                if (!(data.type === 'kefu' && data.scene === 5)) {
                    // 除了人工客服场景，记录所有问题
                    var allQuestions = localStorage.getItem('allQuestions');
                    var nowDate = new Date();
                    allQuestions = !!allQuestions ? JSON.parse(allQuestions) : [];
                    allQuestions.unshift({
                        q: options.question,
                        d: nowDate.getFullYear() + ',' + (nowDate.getMonth() + 1) + ',' + nowDate.getDate() + ',' + nowDate.getHours() + ',' + nowDate.getMinutes() + ',' + nowDate.getSeconds()
                    });
                    allQuestions = allQuestions.slice(0, historyQuestionsMaxCount);
                    allQuestions = JSON.stringify(allQuestions);
                    localStorage.setItem('allQuestions', allQuestions);
                }

                if (data.ret === 0) {
                    SR.App.trigger('gotAnswer', [data, options.askOptions]);
                    templateHTML = SR.modules.answer.packageData({
                        type: data.type,
                        scene: data.scene,
                        data: data,
                        msg: data.msg,
                        tip: data.tip,
                        id: answerDomId,
                        askOptions: options.askOptions
                    });
                    // 记录提问信息
                    SR.data.questions.push(options.question);
                    // 记录历史提问
                    if (SR.state.showHistoryQuestions && !options.askOptions.isLoadHistory && !(data.type === 'kefu' && data.scene === 5)) {
                        var historyQuestions = localStorage.getItem('historyQuestions');
                        var nowDate = new Date();
                        historyQuestions = !!historyQuestions ? JSON.parse(historyQuestions) : [];
                        historyQuestions.unshift({
                            q: options.question,
                            d: nowDate.getFullYear() + ',' + (nowDate.getMonth() + 1) + ',' + nowDate.getDate() + ',' + nowDate.getHours() + ',' + nowDate.getMinutes() + ',' + nowDate.getSeconds()
                        });
                        historyQuestions = historyQuestions.slice(0, historyQuestionsMaxCount);
                        historyQuestions = JSON.stringify(historyQuestions);
                        localStorage.setItem('historyQuestions', historyQuestions);
                    }
                    if (SR.state.mode === 'api') {
                        $body.addClass('loadSuccess');
                    }
                } else {
                    SR.App.trigger('noAnswer', [data]);
                    if (data.scene === 'error' || data.scene === 0) {
                        setTimeout(function() {
                            SR.modules.answer.repeat(options.askOptions.askId || options.askId, options.askOptions);
                        }, (showAnimate ? outAnimateTime + removeTime : 0));
                    }
                    templateHTML = SR.modules.answer.packageData({
                        scene: data.scene,
                        type: data.type,
                        msg: data.msg,
                        tip: data.tip,
                        id: answerDomId,
                        etgRecommend: data.etgRecommend,
                        recommand: data.data && data.data.recommand,
                        categoryGuide: SR.state.categoryGuide,
                        askOptions: options.askOptions,
                    });
                }

                function renderScene() {
                    // 场景添加至 Dom 中
                    $targetDom.after(templateHTML);
                    // 广播 renderAnswer 事件，用于特定场景处理
                    var triggerEvent = 'renderAnswer' 
                                        + (options.askOptions.isLoadHistory ? ':history' : '')
                                        + (options.askOptions.isTheater ? ':theater' : '');
                    SR.App.trigger(triggerEvent, [data]);
                    SR.state.isDebug && console.info('fire:' + triggerEvent);
                    // 停止问题动画
                    if ($scrollWrap.is(':animated')) {
                        $scrollWrap.stop();
                    }
                    // 其它回调处理
                    SR.modules.answer.renderCallback({
                        question: options.question,
                        data: data,
                        askDomId: options.askId,
                        answerDomId: answerDomId,
                        askOptions: options.askOptions,
                        showAnimate: showAnimate,
                        enterAnimateStyle: enterAnimateStyle
                    });
                }
                if (showAnimate) {
                    SR.util.outAnimate($loading, enterAnimateStyle, outAnimateStyle, outAnimateTime, removeTime);
                    setTimeout(function() {
                        renderScene();
                    }, outAnimateTime + removeTime);
                } else {
                    $loading.remove();
                    renderScene();
                }
            })
            .fail(function() {
                var errorDomId = 'answerErrorId-' + Date.now();
                var templateHTML = SR.modules.answer.packageData({
                    id: errorDomId,
                    scene: 'error',
                    type: 'stock',
                    msg: '网络错误, 请重试'
                });
                var askId = isAskAgain ? options.askOptions.askId : options.askId;
                SR.App.trigger('askFail', [options]);
                function renderScene() {
                    SR.modules.answer.renderCallback({
                        question: options.question,
                        data: {},
                        askDomId: options.askId,
                        answerDomId: errorDomId,
                        askOptions: options.askOptions,
                        showAnimate: showAnimate,
                        enterAnimateStyle: enterAnimateStyle
                    });
                }
                if (showAnimate) {
                    SR.util.outAnimate($loading, enterAnimateStyle, outAnimateStyle, outAnimateTime, removeTime);
                    setTimeout(function() {
                        SR.modules.answer.repeat(askId, options.askOptions);
                        $targetDom.after(templateHTML);
                        SR.util.enterAnimate($('#' + errorDomId), enterAnimateStyle + ' fastest');
                        renderScene();
                    }, outAnimateTime + removeTime);
                } else {
                    $loading.remove();
                    $targetDom.after(templateHTML);
                    renderScene();
                }
            })
            .always(function() {
                $body.removeClass(loadingTag);
                options.askOptions.callbackHandle && options.askOptions.callbackHandle(options);
            });
    }
})();
